import { Text, View } from "@react-pdf/renderer";
import { makePDFTagStyleSheet, PDFTagStyleProps } from "./styles";

export interface PDFTagProps {
  text: string;
  style?: PDFTagStyleProps;
}
function PDFTag({ text, style }: PDFTagProps) {
  const styleSheet = makePDFTagStyleSheet(style);

  return (
    <View style={styleSheet.tag}>
      <Text>{text}</Text>
    </View>
  );
}

export default PDFTag;
